<script lang="ts">
    // This component is available for use in JAF application pages as <jungletv-success>
</script>

<div class="p-2 flex flex-row shadow-sm rounded-md border border-green-600 bg-green-200 text-gray-800">
    <i class="fas fa-check-circle text-green-600 ml-2 h-full float-left mt-1.5 mr-3" />
    <p><slot></slot></p>
</div>
